export enum CalculationTargetType {
  Composition = 0,
  CompositionType = 1
}
